// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ticket_account_frame__Xxkdy {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: var(--color-neutral-200);
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-large);
    -webkit-border-radius: var(--radius-large);
    -moz-border-radius: var(--radius-large);
    -ms-border-radius: var(--radius-large);
    -o-border-radius: var(--radius-large);
}

.Ticket_account_frame_header__TLqvg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid var(--color-neutral-500);
    padding-bottom: 16px;

}

.Ticket_account_frame_header__TLqvg>a {
    flex-shrink: 0;
}

.Ticket_table__NyFpf {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

.Ticket_table__NyFpf table { 
    width: 100%;
    min-width: 800px;
}

@media screen and (min-width : 768px) {
    .Ticket_account_frame__Xxkdy {
        padding: 32px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Ticket.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,0CAA0C;IAC1C,0CAA0C;IAC1C,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iDAAiD;IACjD,oBAAoB;;AAExB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".account_frame {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n    background-color: var(--color-neutral-200);\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-large);\n    -webkit-border-radius: var(--radius-large);\n    -moz-border-radius: var(--radius-large);\n    -ms-border-radius: var(--radius-large);\n    -o-border-radius: var(--radius-large);\n}\n\n.account_frame_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    border-bottom: 1px solid var(--color-neutral-500);\n    padding-bottom: 16px;\n\n}\n\n.account_frame_header>a {\n    flex-shrink: 0;\n}\n\n.table {\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.table table { \n    width: 100%;\n    min-width: 800px;\n}\n\n@media screen and (min-width : 768px) {\n    .account_frame {\n        padding: 32px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account_frame": `Ticket_account_frame__Xxkdy`,
	"account_frame_header": `Ticket_account_frame_header__TLqvg`,
	"table": `Ticket_table__NyFpf`
};
export default ___CSS_LOADER_EXPORT___;
